import React, { useEffect, useState, lazy } from 'react';
import { useSelector } from "react-redux";
import ProductsDivider from './ProductsDivider';
import { Link } from "react-router-dom";
import { Segment } from "semantic-ui-react";
import productSeries from '../../../../constants/WiCanvasProductSeriesNew.json';
import VideoModal from '../../Modal/VideoModal';
import { justifyProductName, justifyNameToPath } from '../../../../utils';
import './Products.css';
const MobileProductsIndex = lazy(() => import('../../MobileVersion/Products/MobileProductsIndex'));

const VideoBlock = props => {
    const url = "https://wicanvas.wistron.com/video/videopage_01.mp4";
    const videoImages = require("../../../../images/videoPage/videopage_01.jpg");
    return (
        <Segment
            className="__d_p_header_segment"
            basic
            style={{ minHeight: "250px" }}
            vertical
        >
            <h2 className="__d_p_header_title">{props.lang.get("product-index-title")}</h2>
            <div className="__d_p_header_video">
                <VideoModal video={url} thumb={videoImages} showBtn="true" />
            </div>
        </Segment>
    )
}



const ProductsIndex = props => {
    const [productType, setProductType] = useState(undefined);
    const currentLanguage = useSelector((state) => state.langAction.currentLanguage);
    useEffect(() => {
        setProductType(justifyProductName(window.location.pathname.split("/").pop()));
        window.scrollTo(0, 0);
    }, []);

    return (
        window.innerWidth > 768
            ? (
                <div style={{ paddingTop: "53px", paddingBottom: "50px" }}>
                    {
                        productType &&
                        Object.keys(productSeries[productType]).map((series, seriesIndex) => {
                            const typeQuery = productSeries[productType][series][currentLanguage] || productSeries[productType][series].other;
                            return (
                                <div key={seriesIndex}>
                                    {seriesIndex !== 0 && <ProductsDivider />}
                                    <Segment className="__d_p_series" basic vertical>
                                        <h3 className="__d_p_series_title">{series === 'WiCanvas Outdoor' ? "WiCanvas Semi-Outdoor / Outdoor" : series}</h3>
                                        <ul className="__d_p_series_list">
                                            {
                                                typeQuery.map((type, typeIndex) => {
                                                    return (
                                                        <li className="__d_p_types" key={typeIndex}>
                                                            <ul className={`__d_p_types_list ${series.toLowerCase().replace(/ /g, "")}`}>
                                                                {type.map((name, nameIndex) => {
                                                                    const img = (series === 'WiCanvas Office' && name === 'WiBox') ?
                                                                      require(`../../../../images/products/menu/${name}_${series}.png`)
                                                                      : require(`../../../../images/products/menu/${name}.png`);
                                                                    return (
                                                                        <li key={nameIndex} className="__d_p_types_list_block">
                                                                            <Link to={`${window.location.pathname}/${justifyNameToPath(series)}/${justifyNameToPath(name)}`}>
                                                                                <div className="__d_p_types_list_block_img">
                                                                                    <img src={img} alt={name + ' - Digital Signage | ' + series} />
                                                                                    <p className="__d_p_types_list_block_imgTxt">{name}</p>
                                                                                </div>
                                                                            </Link>
                                                                        </li>
                                                                    )
                                                                })}
                                                            </ul>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </Segment>
                                </div>
                            )
                        })
                    }
                </div>
            )
            : <MobileProductsIndex />
    );
}



export default ProductsIndex;